const visibleLayers = [`zcm:0100_ce_limites_municipais_2025_pol`];

function geoCSVReader(resource, geoWorkspace, serverURL, serverType) {


  const tree = [];
  const layers = [];
  const rows = resource.split('\n').filter(Boolean);

  const _visible = visibleLayers
    ? visibleLayers
    : [];

  for (const row of rows) {
    const data = row.split(';');

    const titles = [data[1], data[2], data[3], data[4]].map(s => (s ?? '').trim());
    const lastNonEmptyLevel = Math.max(...titles.map((t, i) => (t ? i : -1)));

    const folderSequence = titles.filter(Boolean).join('_');

    ensurePathCompatible(tree, titles, lastNonEmptyLevel);

    const show = (data[10] ?? '').trim() === 'Sim';
    if (show) {
      const wmsRaw = (data[5] ?? '').trim();
      const wmsName = `${geoWorkspace}:${wmsRaw.toLowerCase()}`;

      layers.push({
        wmsName,
        title: (data[6] ?? '').trim(),
        folder: lastNonEmptyLevel >= 0 ? titles[lastNonEmptyLevel] : '',
        folderSequence,
        url: serverURL,
        visibility: _visible.includes(wmsName),
        queryable: true,
        serverType,
        isAllowedToStatistics: (data[9] ?? '').trim() === 'Sim',
        bbox: data[11],
        attributes: data[12],
        geomType: data[13]
      });
    }
  }

  return { tree, layers };
}


function ensurePathCompatible(rootArray, titles, lastNonEmptyLevel) {
  let currentArray = rootArray;

  if (lastNonEmptyLevel < 0) return;

  for (let i = 0; i <= lastNonEmptyLevel; i++) {
    const title = (titles[i] ?? '').trim();
    if (!title) break;

    let idx = currentArray.findIndex(n => n.title === title);
    if (idx === -1) {
      const isLast = (i === lastNonEmptyLevel);
      currentArray.push({
        title,
        folderSequence: titles.slice(0, i + 1).filter(Boolean).join('_'),
        subFolder: isLast ? null : [] 
      });
      idx = currentArray.length - 1;
    } else {
      currentArray[idx].folderSequence = titles.slice(0, i + 1).filter(Boolean).join('_');

      const goingDeeper = i < lastNonEmptyLevel;
      if (goingDeeper && currentArray[idx].subFolder === null) {
        currentArray[idx].subFolder = []; 
      }
      if (!('subFolder' in currentArray[idx])) {
        currentArray[idx].subFolder = goingDeeper ? [] : null;
      }
    }

    const node = currentArray[idx];
    if (i < lastNonEmptyLevel) {
      if (!Array.isArray(node.subFolder)) node.subFolder = [];
      currentArray = node.subFolder;
    }
  }
}


export default geoCSVReader;